import GetCommand from '@/api/GetCommand';
import ApiReceiver from '@/api/ApiReceiver';
import PutCommand from '@/api/PutCommand';
import IQtiSession from '../models/IQtiSession';
import RetryManager from '@/api/RetryManager';
import CommandPollingManager from '@/controllers/polling/CommandPollingManager';
import IPauseState from '../models/IPauseState';
import ICommandPollingNotificationHandler from '@/controllers/polling/ICommandPollingNotificationHandler';
import { PauseStateValue } from '@/controllers/pause/PauseManager';
import IApiCommand from '@/api/IApiCommand';

class SessionApiController {
  private readonly retryManager: RetryManager = new RetryManager();
  private readonly apiReceiver: ApiReceiver = new ApiReceiver();
  private readonly SESSION_PATH: string;
  private pauseStatusCommandPollingManager: CommandPollingManager<IPauseState> | undefined;
  constructor(baseServiceUrl: string | undefined) {
    this.SESSION_PATH = `${baseServiceUrl}/qti-player/api/qti-sessions`;
  }

  loadSessionData<T = never>(sessionId: string): Promise<T | null> {
    return this.retryManager.runCommand(new GetCommand<T>(this.apiReceiver, this.SESSION_PATH + '/' + sessionId));
  }

  createPollingManager(
    sessionId: string,
    notificationHandler: ICommandPollingNotificationHandler<IPauseState>
  ): CommandPollingManager<IPauseState> {
    return new CommandPollingManager(
      new GetCommand<IPauseState>(this.apiReceiver, this.SESSION_PATH + '/' + sessionId + '/state'),
      20000,
      notificationHandler
    );
  }

  updatePauseState(qtiSessionId: string, sessionId: string, pauseState: PauseStateValue): Promise<IPauseState> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new Promise<IPauseState>((resolve, reject) => {
      that.retryManager
        .runCommand(
          new PutCommand<unknown>(
            that.apiReceiver,
            that.SESSION_PATH + '/' + qtiSessionId + '/state',
            { sessionId: sessionId, state: pauseState },
            'pause_state'
          )
        )
        .then((data) => {
          resolve(data as IPauseState);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  createPersistenceCommand(sessionData: IQtiSession | undefined): IApiCommand<IQtiSession> | null {
    if (sessionData) {
      return new PutCommand<IQtiSession>(
        this.apiReceiver,
        this.SESSION_PATH,
        JSON.parse(JSON.stringify(sessionData)),
        'session'
      );
    } else {
      return null;
    }
  }
}

export default SessionApiController;
